import { SkillDefinition } from "./types";

export const defendSkill = {
  id: "defend",
  name: "Defend",
  description: "Guard against incoming attacks, reducing damage by your armor.",
  requiresTarget: false,
  use: ({ setPlayerDefending, getPlayerArmor }) => {
    setPlayerDefending(true);
    const armor = getPlayerArmor();
    return [{ kind: "playerDefend", armor }];
  },
} satisfies SkillDefinition<"defend">;
